import classNames from 'classnames';
import React from 'react';

import Tooltip from './../../wix-rich-content-common/lib/Tooltip';
import {
  VERTICAL_EMBED_BUTTON,
  VERTICAL_EMBED_SUBTITLE,
  VERTICAL_EMBED_TITLE,
} from './../data-hooks';

import styles from '../statics/styles/widget-scss';

export type SubtitleInfo = {
  leftSubtitle?: string;
  rightSubtitle?: string;
};

type CardContentProps = {
  title: string;
  info?: SubtitleInfo;
  buttonText: string;
  disabled?: boolean;
  t: (key: string) => string;
};

export const CardContent: React.FC<CardContentProps> = props => {
  const { title, info, buttonText, disabled, t } = props;
  return (
    <div className={styles.content}>
      <div className={styles.contentText}>
        <div className={styles.title} data-hook={VERTICAL_EMBED_TITLE}>
          {ellipsisTitle(title)}
        </div>
        {info && <Subtitle info={info} />}
      </div>
      <Tooltip content={disabled ? t('VerticalEmbed_Disabled_Button_Tooltip') : null}>
        <div
          data-hook={VERTICAL_EMBED_BUTTON}
          className={classNames(styles.button, { [styles.button_disabled]: disabled })}
        >
          <div className={styles.buttonText}>{buttonText}</div>
        </div>
      </Tooltip>
    </div>
  );
};

const Subtitle: React.FC<{ info: SubtitleInfo }> = ({ info }) => {
  return info.leftSubtitle ? (
    <div className={styles.subtitle} data-hook={VERTICAL_EMBED_SUBTITLE}>
      {info.leftSubtitle}
      {info.rightSubtitle && (
        <span>
          <span className={styles.right}>|</span>
          {info.rightSubtitle}
        </span>
      )}
    </div>
  ) : null;
};

const ellipsisTitle = (title: string) => {
  return title.length <= 80 ? title : `${title.substring(0, 80)}...`;
};
